import { useState } from 'react';

import { Grid, ListItem } from '@material-ui/core';
import { useQuery } from 'react-query';

import { InputSearch } from '../../../components/InputSearch';
import { SelectCustom } from '../../../components/SelectCustom';
import { useAuthContext } from '../../../context/AuthContextProvider';
import { getMarkets, getSegments } from '../../../services/institution';

export default function HeaderInstitutions({
  classes,
  setFilters,
  filters,
  setLastFound,
  setSortHistory,
}) {
  const { auth } = useAuthContext();
  const [segments, setSegment] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [selectedSegments, setSelectedSegments] = useState([]);
  const [selectedMarkets, setSelectedMarkets] = useState([]);
  const [search, setSearch] = useState('');

  const { isLoading: segmentsLoading } = useQuery('segments', getSegments, {
    onSuccess: ({ data }) => {
      setSegment(data);
    },
  });

  const { isLoading: marketsLoading } = useQuery('markets', getMarkets, {
    onSuccess: ({ data }) => {
      setMarkets(
        data.filter((market) =>
          ['CRA', 'CRI', 'FII', 'FIDC', 'FIAGRO'].includes(market.name),
        ),
      );
    },
  });

  const handleSelectedSegments = (event) => {
    const { value } = event.target;
    setSelectedSegments(value);
    setFilters({
      ...filters,
      segments: value.map(({ name }) => name),
    });
    setLastFound(null);
    setSortHistory({});
  };

  const handleSelectedMarkets = (event) => {
    const { value } = event.target;
    setSelectedMarkets(value);
    setFilters({
      ...filters,
      markets: value.map(({ name }) => name),
    });
    setLastFound(null);
    setSortHistory({});
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    setFilters({
      ...filters,
      keyword: value,
    });
    setLastFound(null);
    setSortHistory({});
  };

  return (
    <Grid container className={classes.container}>
      <InputSearch
        classes={classes}
        label="Pesquise nome ou CNPJ"
        handleChange={handleChange}
        value={search}
        disabled={
          !auth?.user?.subscription?.plan?.permissions
            ?.instituicoes_barra_pesquisa
        }
      />
      <Grid item xs={12} md={3}>
        <ListItem className={classes.listItem}>
          <SelectCustom
            name="segments"
            classes={classes}
            handleChange={handleSelectedSegments}
            options={segments}
            loading={segmentsLoading}
            label="Segmentos"
            values={selectedSegments}
            disabled={
              !auth?.user?.subscription?.plan?.permissions?.instituicoes_filtros
            }
          />
        </ListItem>
      </Grid>
      <Grid item xs={12} md={3}>
        <ListItem className={classes.listItem}>
          <SelectCustom
            name="markets"
            classes={classes}
            handleChange={handleSelectedMarkets}
            options={markets}
            loading={marketsLoading}
            label="Mercados"
            values={selectedMarkets}
            disabled={
              !auth?.user?.subscription?.plan?.permissions?.instituicoes_filtros
            }
          />
        </ListItem>
      </Grid>
    </Grid>
  );
}
